import { createSlice } from '@reduxjs/toolkit';
const INITIAL_STATE = {
    activeTabId: ''
};
const settingsSlice = createSlice({
    name: 'settings',
    initialState: INITIAL_STATE,
    reducers: {
        setActiveTab (state, action) {
            state.activeTabId = action.payload.activeTabId;
            return state;
        }
    }
});
const { actions, reducer } = settingsSlice;
export const tabManagerReducer = reducer;
export const { setActiveTab } = actions;
export const TabManagerActions = {
    setActiveTab (tabId) {
        return setActiveTab({
            activeTabId: tabId
        });
    }
};
